var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10a1 1 0 010 2H1a1 1 0 010-2h14zM9 5a1 1 0 110 2H1a1 1 0 110-2h8z"
  })))));
}
export default SvgMenu;